export default __webpack_public_path__ + "static/media/Cropduster.518c662c.jpg";